import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientModel } from '../../../shared/models/client.model';

@Component({
    selector: 'payment-identification-ready',
    templateUrl: './payment.identification.ready.component.html',
})
export class PaymentIdentificationReadyComponent {
    @Input() user: ClientModel;
    @Output() activated: EventEmitter<null> = new EventEmitter();

    /**
     * resetedIdentifiedToken event listener.
     **/
    public onResetedIdentifiedUser() {
        this.activated.emit();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/payment/identification/ready/payment.identification.ready.component.ts